import { configureStore, Middleware } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { apiMiddlewares, rootReducer } from "./reducer";
import { preloadState } from "./utils";

export const store = configureStore({
  reducer: rootReducer,
  preloadedState: preloadState(),
  devTools: process.env.REACT_APP_BASE_URL?.includes("django-backend-stage")
    ? { maxAge: 50, serialize: true }
    : false,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(...(apiMiddlewares as Middleware[])),
});

setupListeners(store.dispatch);

store.subscribe(() => {
  try {
    const state = store.getState().table;
    localStorage.setItem("columns", JSON.stringify(state.columnsPersist));
    localStorage.setItem("columns-order", JSON.stringify(state.columnsOrder));
    localStorage.setItem("columns-width", JSON.stringify(state.columnsWidth));
  } catch (error) {
    console.error("Failed to save state", error);
  }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
